export default {
     OneToOneTarget: "OneToOneTarget",
     OneToManyTargets: "OneToManyTargets",
     ManyToManyTargets: "ManyToManyTargets",
     ManyToOneTarget: "ManyToOneTarget",
}